import React, { useEffect } from "react";
import "./style.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Menu } from "react-feather";
import NavbarTop from "../../../components/NavbarTop";
import ButtonBack from "../../../global-components/src/components/buttons/back";
import {
    LeftContent,
    RightContent,
    SponsoredContent,
} from "../../../global-components/src/components/screen/left-content";
import { shouldHideMenus } from "../../../utils/platform";
interface ScreenProps {
    title?: any;
    contentMenu?: any;
    className?: string;
    paddingTopTitle?: boolean;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    withouPadding?: boolean;
    hasLateral?: boolean;
    showMenuIcon?: boolean;
}

const Screen: React.FC<ScreenProps> = ({ title, children, contentMenu, paddingTopTitle, withouPadding = false, className, showMenuIcon=true, hasLateral=true, footer }) => {
    const hideMenus = shouldHideMenus();
    useEffect(() => {
        const root = document.getElementById("root");
        if (root) root.style.overflow = "hidden";
    
        return () => {
            if (root) root.style.overflow = "";
        };
    }, []);

    useEffect(() => {
        const root = document.getElementById("small-menu-top");
        if (root && window.innerWidth >= 850) root.style.display = "none";
    
        return () => {
            if (root && window.innerWidth >= 850) root.style.display = "none";
        };
    }, [window.innerWidth]);

    useEffect(() => {
        const root = document.querySelector(".modal-body") as HTMLElement;
        
        if (root && window.innerWidth >= 850) {
            root.style.height = "100%!important";
            root.style.maxHeight = "100%!important";
            root.style.minHeight = "100%!important";
        }
    
        return () => {
            if (root && window.innerWidth >= 850) {
                root.style.height = "100%!important";
                root.style.maxHeight = "100%!important";
                root.style.minHeight = "100%!important";
            }
        };
    }, [window.innerWidth]);
    
    
    return (
        <>
        {!hideMenus && (
            <NavbarTop hiddenInScroll={false} showMenuIcon={showMenuIcon} title={title}>
                {contentMenu ? (
                    <>
                    {contentMenu}</>
                ) : null}
            </NavbarTop>
        )}

            {hasLateral && !hideMenus ? (
                <>
                    <LeftContent/>
                    <RightContent>
                        <SponsoredContent/>
                    </RightContent>
                </>
            ): null}

            <div className={`container container-screen container-feed container-comments ${className}`} style={{paddingTop: hideMenus ? 0 : "60px", minWidth: "100%!important", minHeight: "100dvh"}}>
                <div className="row row-screen" style={{justifyContent: "center", height: "100%"}}>
                    <div className="col-md-4">
                        <div className="div-modal-curtida">
                            <div className="modal-dialog cover-mobile">
                                <div className="modal-content padding-modal" id="modal-content-body" style={{ padding: withouPadding ? 0 : ""}}>
                                    <h5 className={`text-no-wrap modal-title ml-5 ${paddingTopTitle ? "padding-top-title-screen" : ""}`} id="modal-curtida"></h5>
                                    {title && !hideMenus ? (
                                        <div className="none-cel">
                                            <div className="user-select-none small-menu-top align-items-center justify-content-between">
                                                <div className="d-flex justify-content-start align-items-center" style={{ width: "calc(100% - 20px)" }}>
                                                    <span className="none-cel">
                                                        <ButtonBack/>
                                                    </span>

                                                    <h4 className={`text-no-wrap none-cel modal-title ml-5 ${paddingTopTitle ? "padding-top-title-screen" : ""}`} id="modal-curtida">{title}</h4>
                                                </div>

                                                <div className="d-flex">
                                                        {contentMenu ? (
                                                            <>
                                                            {contentMenu}</>
                                                        ) : null}
                                                        
                                                        {showMenuIcon ? (
                                                            <div className="col cursor-pointer none-cel" data-bs-toggle="offcanvas" 
                                                                data-bs-target="#offcanvasWithBothOptions" 
                                                                aria-controls="offcanvasWithBothOptions">
                                                                <Menu data-feather="menu" style={{ opacity: 0.6 }}/>
                                                            </div>
                                                        ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                        
                                    <div className="modal-body modal-body-screen content-screen overflow-minus" id="modal-comments-body" style={{background: "var(--background-post)", overflowY: "auto", overflowX: "hidden", padding: withouPadding ? 0 : "", paddingLeft: "0!important", ...(hideMenus ? { minHeight: "100dvh", maxHeight: "100dvh", height: "100dvh" } : {})}}>
                                        {children}
                                    </div>
                                    {footer}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Screen;
